<template>
  <div>
    <JobSearch :countryCode="countryCode"> </JobSearch>
  </div>
</template>

<script>
import JobSearch from '@/pages/jobs/JobSearch';
import { jobSearchInit, getMetaData } from '@/pages/jobs/helper';
import { buildMetaHead } from '~/helpers/meta';

export default {
  name: 'CountryJobSearch',
  components: {
    JobSearch
  },
  head() {
    return buildMetaHead({
      ...getMetaData({ country: this.country }),
      path: this.$route.path,
      imageUrl: process.env.BASE_URL + '/images/thehub_2022_find_startup_jobs.jpg'
    });
  },
  data: () => ({ countryCode: '' }),
  async asyncData({ app, store, query, error, params, route }) {
    return await jobSearchInit({ app, store, query, error, params, route });
  },
  async mounted() {}
};
</script>

<style scoped lang="scss"></style>
